import { useQuery } from '@apollo/client';

import {
  GetShadefinderAppIdQuery,
  GetShadefinderAppIdQueryVariables,
} from '@notino/shared/definitions/types';

import getShadefinderAppId from './getShadefinderAppIdQuery.graphql';

export const useShadefinderAppId = (): string => {
  const { data: requestInfoData } = useQuery<
    GetShadefinderAppIdQuery,
    GetShadefinderAppIdQueryVariables
  >(getShadefinderAppId);
  return requestInfoData?.RequestHeaders.shadefinderAppId;
};
